import { render, staticRenderFns } from "./HppAdjDetails.vue?vue&type=template&id=b06202fa&"
import script from "./HppAdjDetails.vue?vue&type=script&lang=js&"
export * from "./HppAdjDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports